<template>
  <div>
    <div
      class="d-flex itm px-2"
      v-if="!processing"
    >
      <div
        class="mr-4 animate__animated animate__fadeIn itm-img-container"
        v-if="item.image"
        @click="goToItem()"
      >

        <div
          class="itm-img bg-light"
          v-bind:style="{
                                                            'background-image':
                                                                'url(/storage/menu_item_image/' +
                                                                menu.user.id +
                                                                '/medium/' +
                                                                item.image +
                                                                '?v=' +
                                                                item.updated_at +
                                                                ')'
                                                        }"
        >
        </div>

      </div>
      <div
        class="mr-4 animate__animated animate__fadeIn itm-img-container"
        v-else
      >
        <div
          @click="goToItem()"
          class="itm-img"
        >
        </div>
      </div>
      <div class="flex-grow-1">
        <div @click="goToItem()">
          <div
            class="text-danger font-weight-bold small"
            v-if="(cartDeliveryMode==1 && item.is_take_out==0)"
          >Unavailable for pickup</div>
          <h2 class="mb-1">{{ item.name }}</h2>
          <p
            v-if="item.description"
            class="itm-txt mb-0"
          >
          <pre class="font-family-1 mb-1 tiny-text text-muted">{{limitedDescriptionText}}</pre>
          </p>

          <div
            v-for="(price,index) in item.prices"
            :key="'p'+index"
          >
            <div
              v-if="price.selected"
              class="d-flex justify-content-between"
            >
              <div class="text-muted w-75">{{ price.label }}</div>
              <div class="font-weight-bold ">{{ rawMenu.user.currency.symbol
                                }}{{ price.amount | centsToDollars }}</div>

            </div>
          </div>
          <div
            class="small mt-3"
            v-for="(option,index) in item.options"
            :key="'o'+index"
          >
            <div
              v-if="option.selected"
              class="d-flex justify-content-between"
            >

              <div class="text-muted w-75">{{ option.label }}</div>
              <div> +{{
                                                                rawMenu.user
                                                                    .currency
                                                                    .symbol
                                                            }}{{
                                                                option.amount | centsToDollars
                                                            }}</div>
            </div>
          </div>
          <div
            v-for="(group,i) in item.option_groups"
            :key="'g'+i"
          >
            <div
              class="my-1"
              v-if="hasSelectedOption(group)"
            >
              <label class="mb-0">{{ group.label}}</label>
              <div
                v-for="(itm,i) in group.options"
                :key="'go'+i"
              >
                <div
                  class="small d-flex justify-content-between"
                  v-if="itm.selected"
                >
                  <div class="text-muted w-75">{{ itm.label }}</div>
                  <div>+{{ rawMenu.user.currency.symbol }}{{ itm.amount | centsToDollars}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="rawMenu.user.enable_rewards && item.punch_card_rewards.length">
          <label class="small rwd-color font-weight-bold">{{ item.punch_card_rewards[0].label}}</label>
          <div
            v-if="customer"
            class="tiny-text text-muted"
          >You have bought <span class="rwd-color font-weight-bold">{{customerAmountBought}}</span> of these. <span v-if="item.punch_card_rewards[0].items_bought_reward_threshold>customerAmountBought">Buy <span class="rwd-color font-weight-bold">{{item.punch_card_rewards[0].items_bought_reward_threshold-customerAmountBought}} more</span> and get the next one free<sup>*</sup></span><span v-else>Reward discount will be applied at checkout.<sup>*</sup> </span></div>
          <div
            v-else
            class="tiny-text text-muted"
          >Buy this item {{ item.punch_card_rewards[0].items_bought_reward_threshold }} times and get the <span>{{ parseInt(item.punch_card_rewards[0].items_bought_reward_threshold) + 1 }}<span v-if="item.punch_card_rewards[0].items_bought_reward_threshold==1">nd</span><span v-if="item.punch_card_rewards[0].items_bought_reward_threshold==2">rd</span><span v-if="item.punch_card_rewards[0].items_bought_reward_threshold>3">th</span> one free<sup>*</sup>. Sign-in at checkout and we will add this purchase to your tally.</span> </div>

        </div>
        <div class="mt-3">
          <a
            v-on:click="removeItem()"
            class="delete-text font-weight-bold small mt-3"
          ><i class="fal fa-trash-alt small"></i> Remove</a>
        </div>
      </div>
      <select
        v-model="item.quantity"
        class="form-control q-select"
        @change="updateItem($event)"
      >
        <option
          v-for="n in 100"
          :value="n"
          :key="'qt-'+n"
        >{{ n }}</option>
      </select>
    </div>
    <div
      v-if="processing"
      class="text-center"
    >
      <img
        src="/storage/images/svg-loaders/three-dots.svg"
        width="30"
        class="loader-img"
      />
    </div>
  </div>
</template>
<style scoped>
.itm-img {
  width: 4rem;
  height: 4rem;
  background-position: center !important;
  background-size: cover !important;
  border-radius: 0.25rem;
}
h2 {
  font-size: 1.3rem;
  font-weight: 600;
}
.q-select {
  width: 4.2rem;
  margin-left: 1rem;
  border-radius: 0.5rem;
}
.delete-text {
  color: var(--user-highlight-color) !important;
}
.loader-img {
  opacity: 0.3;
}
.unavailable-item {
  opacity: 0.1;
}
.small {
  font-size: 0.75em;
}
label {
  font-size: 1rem;
}
.rwd-color {
  color: var(--user-highlight-color);
}
</style>
<script>
import menuMixin from "../../mixins/menuMixin";
import accountingMixin from "../../mixins/accountingMixin";
import cartMixin from "../../mixins/cartMixin";
import customerMixin from "../../mixins/customerMixin";

export default {
  mounted() {
    this.getCustomer();
  },
  data() {
    return {
      isMobile: this.isMobileDevice(),
      processing: false,
    };
  },
  methods: {
    hasSelectedOption(group) {
      let hasSelected = false;
      _.forEach(group.options, function (cValue, cKey) {
        if (cValue.selected == true) {
          hasSelected = true;
        }
      });
      return hasSelected;
    },

    goToItem: function () {
      location.href =
        "/" +
        this.menu.user.slug +
        "/menu/" +
        this.item.category.slug +
        "/" +
        this.item.slug;
    },
    removeItem: function () {
      this.processing = true;

      axios
        .post("/api/customer/cart/items/" + this.index, {
          _method: "DELETE",
        })
        .then(
          (response) => {
            this.processing = false;
            this.error = null;
            this.getCart();
          },
          (error) => {
            this.errors = error.response.data.errors;
            this.processing = false;
          }
        );
    },
    updateItem: function () {
      this.processing = true;
      let formData = new FormData();
      formData.append("item", JSON.stringify(this.item));
      formData.append("_method", "PATCH");

      axios
        .post("/api/customer/cart/items/" + this.index, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(
          (response) => {
            this.processing = false;
            this.error = null;
            this.getCart();
          },
          (error) => {
            this.errors = error.response.data.errors;
            this.processing = false;
          }
        );
    },
  },
  computed: {
    cartCount() {
      if (this.cartItems) {
        let quantity = 0;
        let _self = this;
        _.forEach(this.cartItems, function (iValue, iKey) {
          if (iValue.id == _self.item.id) {
            _.forEach(iValue.prices, function (pValue, cKey) {
              if (pValue.selected == true) {
                quantity = quantity + iValue.quantity;
              }
            });
          }
        });
        return quantity;
      }
      return false;
    },
    customerAmountBought: function () {
      let amount = 0;
      if (this.customer && this.item) {
        let _self = this;
        if (_self.item.punch_card_rewards[0]) {
          _.forEach(_self.customer.punch_card_rewards, function (cValue, cKey) {
            if (cValue.id == _self.item.punch_card_rewards[0].id) {
              amount = cValue.pivot.tally;
            }
          });
        }
      }
      return amount;
    },
    limitedDescriptionText: function () {
      if (this.isMobile || this.mockMenu) {
        let len = 50;
        if (!this.item.image) {
          len = 100;
        }
        if (this.item.description.length > len) {
          return this.item.description.substring(0, len) + "...";
        }
      }
      return this.item.description;
    },
  },
  props: {
    menu: {
      type: Object,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  components: {},
  mixins: [accountingMixin, menuMixin, cartMixin, customerMixin],
};
</script>
